import { Res } from 'core/api';
import { Result } from 'core/infrastructure';
import { Command } from 'pos/common';
import { makeTicketReadyToClose, showCloseDocumentScreen } from '../helpers/document-creation';
import * as CloseDayStore from './CloseDayStore';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		closePendingTicket: () => Promise<Result>
	}
}

Command.register('closePendingTicket', 'NO_PRECONDITION', async (): Promise<Result> => {

	const selected = CloseDayStore.getSelectedTicket();
	if (!selected)
		return Result.error();

	const isRefund = CloseDayStore.ticketCanBeClosedAsRefund();
	const confirm = isRefund ? await Message.confirm(Res.Msg.MSG_EMIT_REFUND()) : Result.ok(true);

	if (!confirm.ok)
		return Result.error();

	const result = await makeTicketReadyToClose({
		closeAs: isRefund ? 'Refund' : 'Invoice',
		getTicket: () => CloseDayStore.getSelectedTicket()!,
		setFriendlyName: CloseDayStore.setFriendlyName,
		setTableCompanions: CloseDayStore.setTableCompanions
	});

	if (!result.ok)
		return Result.error();

	return await showCloseDocumentScreen({
		layout: isRefund ? 'CreateRefund' : 'CloseTicket',
		getDocument: () => {
			const ticket = CloseDayStore.getSelectedTicket()!;
			return {
				ticketIds: [ticket.Id],
				ticketGlobalId: ticket.GlobalId,
				pendingAmount: Math.abs(ticket.PendingAmount),
				customer: ticket.Customer
			};
		},
		setCustomer: CloseDayStore.setCustomer,
		closeDocument: params => isRefund ? CloseDayStore.refund(params) : CloseDayStore.close(params)
	});

});
